import { locationOptions, teamOptions } from 'modules/core/components/MultiFilters/commonOptions'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import i18n from 'modules/core/lib/i18n'

const filterFields: () => Promise<FilterOption[]> = async () => {
  return [
    {
      label: i18n.t('filters.multi_filters.location'),
      value: 'location',
      type: 'single_choice',
      options: await locationOptions(),
    },
    {
      label: i18n.t('filters.multi_filters.team'),
      value: 'team',
      type: 'single_choice',
      options: await teamOptions(),
    },
  ]
}

export default filterFields
